import moment from 'moment';

export const formatDate = (input: string, onlyMonths?: boolean): string => {
  const date = moment(input);
  return date.format(onlyMonths ? 'MM/YYYY' : 'DD/MM/YYYY');
};
